// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rbf-main[data-v-53a343bd]{border:.2em solid;font-size:larger;font-weight:800;padding-top:.25em;padding-bottom:.25em;padding-left:1em;padding-right:1em;border-radius:5em}", ""]);
// Exports
module.exports = exports;
